import { render, staticRenderFns } from "./linkedQuery.vue?vue&type=template&id=560b048a&"
import script from "./linkedQuery.vue?vue&type=script&lang=js&"
export * from "./linkedQuery.vue?vue&type=script&lang=js&"
import style0 from "./linkedQuery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports